// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-progress-bar {
  height: 10px;
}

.progressbar-container_value {
  position: relative;
}
.progressbar-container_value span {
  position: absolute;
  transform: translateX(-50%);
}`, "",{"version":3,"sources":["webpack://./src/app/core/modules/shared/components/use-progress-bar/use-progress-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;AACF;AACE;EACE,kBAAA;EACA,2BAAA;AACJ","sourcesContent":["ion-progress-bar {\n  height: 10px;\n}\n\n.progressbar-container_value {\n  position: relative;\n\n  span {\n    position: absolute;\n    transform: translateX(-50%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
